
import { useState, useCallback } from "react";
import { Collection, CollectionOperation } from "../types";

/**
 * Hook for managing collection operations (edit/delete)
 */
export const useCollectionOperations = (getCollectionById: (id: string) => Collection | undefined) => {
  // Simple operation state
  const [operation, setOperation] = useState<CollectionOperation>({
    isOpen: false,
    type: null,
    collection: null
  });

  // Start edit operation
  const startEditCollection = useCallback((collection: Collection) => {
    // Ensure we have a full collection object with all properties
    const fullCollection = collection.id ? getCollectionById(collection.id) || collection : collection;
    
    console.log("🔶 Starting edit operation for collection:", fullCollection);
    setOperation({
      isOpen: true,
      type: "edit",
      collection: { ...fullCollection } // Create a clean copy to avoid reference issues
    });
  }, [getCollectionById]);

  // Start delete operation
  const startDeleteCollection = useCallback((collection: Collection) => {
    // Ensure we have a full collection object with all properties
    const fullCollection = collection.id ? getCollectionById(collection.id) || collection : collection;
    
    console.log("🔴 Starting delete operation for collection:", fullCollection);
    setOperation({
      isOpen: true,
      type: "delete",
      collection: { ...fullCollection } // Create a clean copy to avoid reference issues
    });
  }, [getCollectionById]);

  // Close any open operation
  const closeOperation = useCallback(() => {
    console.log("✅ Closing operation");
    setOperation({
      isOpen: false,
      type: null,
      collection: null
    });
  }, []);

  return {
    operation,
    startEditCollection,
    startDeleteCollection,
    closeOperation
  };
};
